export const MAP_BREAKPOINT = 765;

export const FURUPO = 'https://furu-po.com/';

export const OSAKI = 'https://www.town.kagoshima-osaki.lg.jp/';
